export const CollectionsPerPage = 23;
export const ItemsPerPage = 24;
export const ItemsPerPageGuest = 12;
